import { render, staticRenderFns } from "./SendOrderToCustomer.vue?vue&type=template&id=65e81b06&scoped=true&"
import script from "./SendOrderToCustomer.vue?vue&type=script&lang=js&"
export * from "./SendOrderToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e81b06",
  null
  
)

export default component.exports